export const text = {
  delivery: 'Доставка',
  sale: 'Скидка',
  sberspasibo: 'CберСпасибо',
  salePromocode: 'Скидка по промокоду',
  saleBonuses: 'Спишется бонусами',
  addedBonuses: 'Начислится бонусов',
  total: 'Итого',
  free: 'Бесплатно',
  'summary.submit': 'Перейти к оформлению',
  'summary.freeDelivery': 'до бесплатной доставки',
  'cart.header': 'Корзина',
  'cart.empty.header': 'В корзине пока ничего нет',
  'cart.empty.text':
    'Наполните её товарами с главной или воспользуйтесь поиском',
  'cart.empty.textFavorite':
    'Наполните её товарами с главной или из избранного',
  'cart.empty.textSales':
    'Наполните её товарами с главной или загляните в раздел с акциями',
  'button.goToMain': 'На главную',
  'button.goToFavorite': 'В избранное',
  'button.goToSales': 'К акциям',
  'recommendation.title': 'Рекомендуем также',
  'favorite.add': 'Добавить в избранное',
  'favorite.remove': 'Удалить из избранного',
  'promocode.title': 'Промокод',
  'promocode.placeholder': 'Промокод',
  'promocode.apply': 'Применить',
  'promocode.applied': 'Промокод применён',
  'promocode.cancel': 'Отменить',
  'promocode.invalid': 'Не удалось применить',
  'installment.title': 'Этот заказ можно оплатить частями',
  'installment.description': '1 платёж сейчас — 3 потом',
  'installment.accept': 'Понятно',
  'more.isOpened': 'Скрыть',
  'more.isClosed': 'Подробнее',
  item: 'Товар',
  removed: 'удалён',
  fromCart: 'из\u00A0корзины',
  return: 'Вернуть',
  'recipeLabel.description': 'по электронному рецепту',
  'recipe.title':
    'Подобрали товары по\u00A0вашему электронному\u00A0рецепту',
  'recipe.description':
    'Сообщаем о\u00A0возможном наличии лекарств по\u00A0более низкой цене. Можете ознакомиться с\u00A0ними в\u00A0каталоге',
  'clearCart.title':
    'Хотите удалить все товары из\u00A0корзины?',
  'clearCart.yes': 'Да',
  'clearCart.no': 'Нет',
  'expired.short': 'Годен менее 3 мес.',
  'expired.long': 'Годен менее 3 месяцев',
  'ingredient.title': 'Действующее вещество',
  'clear.title': 'Очистить',
  close: 'Закрыть',
  'product.unavailable': 'Товар закончился',
  oneItem: 'товар',
  fewItems: 'товара',
  manyItems: 'товаров',
  'preorder.banner.title':
    'с\u00A0увеличенным сроком доставки ',
  'preorder.banner.title.second': ' отдельно',
  'preorder.banner.formalize': 'оформляется',
  'preorder.banner.formalize.items': 'оформляются',
  'preorder.label.title': 'Доставим с\u00A0',
  'productsList.unavailableForDelivery':
    'Недоступно для доставки',
  'productsList.outOfStock': 'Нет в наличии',
  'fallback.title': 'Что-то пошло не так',
  'fallback.reload': 'Перезагрузить страницу',
  delete: 'Удалить'
};
